/* Josenart 2.0 — header（归属 B / B1）。
   自定义元素 <jn-header>：sticky 状态、移动端抽屉、桌面二级面板、购物袋角标、搜索/购物袋事件派发。
   事件约定（见 base.js 注释）：
     派发 search:open（cancelable）→ B2 预测搜索监听并 preventDefault；无人接管则照常跳 /search
     派发 cart:open（cancelable）  → B3 cart.js 监听并 preventDefault；无人接管则照常跳 /cart
     监听 cart:updated {detail:{cart}} → 刷新角标 */
(function () {
  if (customElements.get('jn-header')) return;

  var MQ_DESKTOP = window.matchMedia('(min-width: 960px)');
  var MQ_NO_HOVER = window.matchMedia('(hover: none)');
  var MQ_REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DRAWER_MS = 380;

  class JnHeader extends HTMLElement {
    connectedCallback() {
      this.host = this.closest('.shopify-section');
      this.drawer = this.querySelector('#JnMenuDrawer');
      this.burger = this.querySelector('[data-menu-open]');
      this.bag = this.querySelector('[data-cart-open]');
      this.count = this.querySelector('[data-cart-count]');
      this.drawerOpen = false;
      this.bindMenuDrawer();
      this.bindNavOverflow();
      this.bindDesktopPanels();
      this.bindIcons();
      this.bindCart();
      this.bindScroll();
    }

    disconnectedCallback() {
      clearTimeout(this._panelCloseTimer);
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('pageshow', this._onPageShow);
      document.removeEventListener('cart:updated', this._onCartUpdated);
      document.removeEventListener('click', this._onDocClick);
      document.removeEventListener('keydown', this._onDocKeydown);
      MQ_DESKTOP.removeEventListener('change', this._onMq);
    }

    /* ---------- sticky / 滚动 ---------- */
    bindScroll() {
      var self = this;
      var mode = this.dataset.sticky || 'always';
      if (mode === 'none') {
        if (this.host) this.host.classList.add('jn-header-host--static');
        return;
      }
      var lastY = window.scrollY;
      var ticking = false;
      this._onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          self.classList.toggle('is-scrolled', y > 8);
          if (mode === 'scroll-up' && !self.drawerOpen && !self.querySelector('.jn-header__item.is-open')) {
            var delta = y - lastY;
            if (Math.abs(delta) > 6) {
              self.classList.toggle('is-hidden', delta > 0 && y > 120);
            }
          }
          lastY = y;
          ticking = false;
        });
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this._onScroll();
    }

    /* ---------- 桌面菜单溢出（priority+）：装不下的一级项收进末尾 “More” ---------- */
    bindNavOverflow() {
      var self = this;
      var list = this.querySelector('.jn-header__list');
      var more = list && list.querySelector('.jn-header__item--more');
      if (!list || !more) return;
      var moreList = more.querySelector('[data-more-list]');
      var items = Array.prototype.filter.call(list.children, function (li) { return li !== more; });
      var busy = false;

      var fill = function (hidden) {
        moreList.textContent = '';
        hidden.forEach(function (li) {
          var group = document.createElement('li');
          group.className = 'jn-header__group';
          var link = li.querySelector(':scope > .jn-header__link').cloneNode(true);
          link.className = 'jn-header__sublink';
          link.removeAttribute('aria-haspopup');
          link.removeAttribute('aria-expanded');
          link.removeAttribute('aria-controls');
          group.appendChild(link);
          var sub = li.querySelector('.jn-header__sub');
          if (sub) {
            // Keep category groups and their third-level links when moved into More.
            var ul = sub.cloneNode(true);
            ul.className = 'jn-header__overflow-children';
            ul.removeAttribute('style');
            group.appendChild(ul);
          }
          moreList.appendChild(group);
        });
      };

      var measure = function () {
        if (busy) return;
        busy = true;
        self.closePanels();
        items.forEach(function (li) { li.hidden = false; });
        more.hidden = true;
        if (MQ_DESKTOP.matches) {
          // Centered flex items can overflow the left edge without increasing
          // scrollWidth. Measure both edges now that dropdowns need visible overflow.
          var overflows = function () {
            var bounds = list.getBoundingClientRect();
            return Array.prototype.some.call(list.children, function (li) {
              if (li.hidden) return false;
              var rect = li.getBoundingClientRect();
              return rect.left < bounds.left - 1 || rect.right > bounds.right + 1;
            });
          };
          if (overflows()) {
            more.hidden = false;
            var hidden = [];
            for (var i = items.length - 1; i >= 0; i--) {
              if (!overflows()) break;
              items[i].hidden = true;
              hidden.unshift(items[i]);
            }
            /* 全收完还溢出说明 More 本身都放不下，属于极窄视口，交给移动端抽屉 */
            fill(hidden);
          }
        }
        busy = false;
      };

      this._onResize = measure;
      window.addEventListener('resize', this._onResize, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      measure();
    }

    /* ---------- 移动端抽屉（<dialog>） ---------- */
    bindMenuDrawer() {
      var self = this;
      var d = this.drawer;
      if (!d || !this.burger) return;
      this.burger.addEventListener('click', function () { self.openMenu(); });
      d.querySelectorAll('[data-menu-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.closeMenu(); });
      });
      // Esc：先动画再真正 close
      d.addEventListener('cancel', function (e) {
        e.preventDefault();
        self.closeMenu();
      });
      // 抽屉内点了链接就收起（Turbo 式站内跳转时也不留残影）
      d.addEventListener('click', function (e) {
        var a = e.target.closest('a[href]');
        if (a && !a.hasAttribute('aria-hidden')) self.closeMenu(true);
      });
      // One expanded top-level category keeps a long mobile menu easy to scan.
      d.querySelectorAll('.jn-header__mitem > .jn-header__macc').forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (!details.open) return;
          d.querySelectorAll('.jn-header__mitem > .jn-header__macc[open]').forEach(function (other) {
            if (other !== details) other.open = false;
          });
        });
      });
      this._onMq = function (e) { if (e.matches) self.closeMenu(true); };
      MQ_DESKTOP.addEventListener('change', this._onMq);
    }

    openMenu() {
      var d = this.drawer;
      if (!d || d.open) return;
      try {
        if (typeof d.showModal === 'function') d.showModal();
        else d.setAttribute('open', '');
      } catch (err) {
        d.setAttribute('open', '');
      }
      this.drawerOpen = true;
      this.classList.remove('is-hidden');
      this.burger.setAttribute('aria-expanded', 'true');
      // 先让 display:block 的初始态画一帧再加类，过渡才会跑；rAF 在后台标签会被冻结，补一个 timeout 兜底
      var show = function () { d.classList.add('is-open'); };
      requestAnimationFrame(function () { requestAnimationFrame(show); });
      setTimeout(show, 80);
    }

    closeMenu(immediate) {
      var d = this.drawer;
      if (!d || !d.open) return;
      d.classList.remove('is-open');
      this.drawerOpen = false;
      this.burger.setAttribute('aria-expanded', 'false');
      var done = function () {
        if (typeof d.close === 'function') d.close();
        else d.removeAttribute('open');
      };
      if (immediate || MQ_REDUCED.matches) done();
      else setTimeout(done, DRAWER_MS);
    }

    /* ---------- 桌面二级面板 ---------- */
    bindDesktopPanels() {
      var self = this;
      var parents = this.querySelectorAll('.jn-header__item--parent');
      if (!parents.length) return;

      parents.forEach(function (li) {
        var link = li.querySelector(':scope > .jn-header__link');
        if (!link) return;

        // 无 hover 的设备（触屏平板）：第一次点父项只展开，第二次才跳转
        link.addEventListener('click', function (e) {
          // More is a disclosure, not a collection destination.
          if (li.classList.contains('jn-header__item--more')) {
            e.preventDefault();
            self.setPanel(li, true);
            return;
          }
          if (!MQ_DESKTOP.matches || !MQ_NO_HOVER.matches) return;
          if (!li.classList.contains('is-open')) {
            e.preventDefault();
            self.closePanels();
            self.setPanel(li, true);
          }
        });

        // 键盘：↓ 展开并进入第一项；Esc 收起回到父项
        link.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            self.setPanel(li, true);
            var first = li.querySelector('.jn-header__sublink');
            if (first) first.focus();
          }
        });
        li.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && li.classList.contains('is-open')) {
            e.preventDefault();
            e.stopPropagation();
            link.focus();
            self.setPanel(li, false);
          }
        });

        // A single open state controls both visibility and accessibility, including Escape.
        li.addEventListener('mouseenter', function () {
          clearTimeout(self._panelCloseTimer);
          if (MQ_DESKTOP.matches && !MQ_NO_HOVER.matches) self.setPanel(li, true);
        });
        li.addEventListener('mouseleave', function () {
          // A short grace period lets the pointer travel diagonally into the panel.
          self._panelCloseTimer = setTimeout(function () {
            if (!li.matches(':hover') && !li.contains(document.activeElement)) self.setPanel(li, false);
          }, 180);
        });
        li.addEventListener('focusin', function (e) {
          // Touch focus arrives before click; opening here would make the first tap navigate.
          if (MQ_DESKTOP.matches && !MQ_NO_HOVER.matches && !li.contains(e.relatedTarget)) self.setPanel(li, true);
        });
        li.addEventListener('focusout', function (e) {
          if (!li.contains(e.relatedTarget)) self.setPanel(li, false);
        });
      });

      this._onDocClick = function (e) {
        if (!self.contains(e.target)) self.closePanels();
      };
      document.addEventListener('click', this._onDocClick);
      this._onDocKeydown = function (e) {
        // Mouse-opened panels may leave keyboard focus on the page body.
        if (e.key === 'Escape' && !document.querySelector('dialog[open]')) self.closePanels();
      };
      document.addEventListener('keydown', this._onDocKeydown);
    }

    setPanel(li, open) {
      if (open) this.closePanels();
      li.classList.toggle('is-open', open);
      var link = li.querySelector(':scope > .jn-header__link');
      if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) this.positionPanel(li);
    }

    positionPanel(li) {
      var panel = li.querySelector(':scope > .jn-header__panel');
      if (!panel || !MQ_DESKTOP.matches) return;
      panel.style.setProperty('--jn-panel-shift', '0px');
      var rect = panel.getBoundingClientRect();
      var viewport = document.documentElement.clientWidth;
      var shift = Math.max(16 - rect.left, Math.min(0, viewport - 16 - rect.right));
      panel.style.setProperty('--jn-panel-shift', shift + 'px');
      panel.style.setProperty('--jn-panel-max-height', Math.max(120, window.innerHeight - rect.top - 16) + 'px');
    }

    closePanels() {
      var self = this;
      this.querySelectorAll('.jn-header__item.is-open').forEach(function (li) { self.setPanel(li, false); });
    }

    /* ---------- 搜索 / 购物袋 ---------- */
    bindIcons() {
      var self = this;
      var search = this.querySelector('[data-search-open]');
      if (search) {
        search.addEventListener('click', function (e) {
          self.closePanels();
          var ev = new CustomEvent('search:open', { bubbles: true, cancelable: true, detail: { source: 'header' } });
          if (!document.dispatchEvent(ev)) e.preventDefault();
        });
      }
      if (this.bag) {
        this.bag.addEventListener('click', function (e) {
          self.closePanels();
          if (self.dataset.cartType !== 'drawer') return;
          var ev = new CustomEvent('cart:open', { bubbles: true, cancelable: true, detail: { source: 'header' } });
          if (!document.dispatchEvent(ev)) e.preventDefault();
        });
      }
    }

    bindCart() {
      var self = this;
      this._onCartUpdated = function (e) {
        var cart = e.detail && e.detail.cart;
        if (cart && typeof cart.item_count === 'number') self.setCount(cart.item_count);
      };
      document.addEventListener('cart:updated', this._onCartUpdated);
      // bfcache 回退时页面是旧快照，角标可能过期
      this._onPageShow = function (e) { if (e.persisted) self.refreshCount(); };
      window.addEventListener('pageshow', this._onPageShow);
    }

    setCount(n) {
      if (this.count) {
        this.count.textContent = n;
        this.count.hidden = n === 0;
      }
      if (this.bag && this.bag.dataset.bagLabel) {
        this.bag.setAttribute('aria-label', this.bag.dataset.bagLabel.replace('__n__', n));
      }
    }

    refreshCount() {
      var self = this;
      var url = (this.dataset.cartUrl || '/cart') + '.js';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) self.setCount(cart.item_count); })
        .catch(function () {});
    }
  }

  customElements.define('jn-header', JnHeader);
})();
